import React from 'react';
import Background from '../../images/Background.png';
import backgroundBlue from '../../images/background-blue.png';
import backgroundPink from '../../images/background-pink.png';
import backgroundGray from '../../images/background-gray.png';
import Skilllogo from '../../images/logos/skill.png';
import Servicelogo from '../../images/logos/service.png';
import nolog_blue from '../../images/nolog_blue.png';
import nolog_pink from '../../images/nolog_pink.png';
import nolog_gray from '../../images/nolog_gray.png';
import Switch from '../../images/Switch.png';
import AddLog from '../../components/AddLog';
import PDFLayout from '../../components/PDFLayout';
import LogGallery from '../../components/LogGallery';
import Badges from '../../components/Badges';
import StudentProfile from '../../components/StudentProfile';
import { Layout, Menu, message, Col, Row, Icon, Button, Tooltip, Popover, Radio } from 'antd';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase'
import profileImage from '../../images/profileImage.png'
import * as R from 'ramda'
import UnavailablePopup from './components/unavailablePopup.js';
import LogsView from './components/logsView'
import DashboardView from './components/dashboardView'
import { withRouter } from 'react-router'
import Log from '../../components/Log';
import { translate } from 'react-i18next';
import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf'
import { serviceTracker_allowed } from '../../config.js'
import logsImage from '../../images/Work Overview Web@2x.png'
import dashboardImage from '../../images/Analytics@x2.png'
const { Header, Content } = Layout;
const  moment = require('moment');

class Skill extends React.Component {

  state = {
    addLogModal: false,
    editingLog: null,
    uploadData: [],
    logs: [],
    LogGallery: false,
    slide: 0,
    profileOpen: false,
    subjects: null,
    logsDisplayedFrom: 0,
    color: "",
    background: null,
    badgesOpen: false,
    classes: null,
    changePass: false,
    termsModal: false,
    hoverOn: null,
    exportMode: false,
    selectedLogs: [],
    unavailablePopup: false,
    years: [],
    selectedYear: null,
    view: 'logs'
  }

  componentDidUpdate(prevProps) {

    if (this.props.profile && !this.state.color) {
      this.getTheme()
    }


    if (this.props.logs && this.props.cluster && this.props.school && this.props.skill && prevProps.logs !== this.props.logs || prevProps.school !== this.props.school ) {
      let myLogs = []
      let logs = Object.entries(this.props.logs)
      logs = logs.filter( log =>
        log[1].user_id == this.props.auth.uid
      )
      const { uid } = this.props.auth
      logs.map( log => {
        let category = Object.entries(this.props.category).filter( category => category[0] == log[1].atl_category.id)[0][1].name
      //  let subject = Object.entries(this.props.subjects).filter( subject => subject[0] == log[1].subject.id)[0][1].name
        let classId = log[1].classId || log[1].class
        let className = classId 
          ? this.props.school.classes && Object.entries(this.props.school.classes).filter(clss => classId == clss[0])
          : this.props.school.classes && Object.entries(this.props.school.classes).filter( clss => clss[1].subject == log[1].subject.id && clss[1].students && clss[1].students[uid])

        if (className.length > 0) {  className = className[0][1].name }
        let cluster = Object.entries(this.props.cluster).filter( cluster => cluster[0] == log[1].atl_cluster.id)[0][1].name
       
        let skill = Object.entries(this.props.skill).filter( skill => skill[0] == log[1].level_skill.id)[0][1].name

        if (!classId) {
          classId = this.props.school.classes && Object.entries(this.props.school.classes).filter( clss => clss[1].subject == log[1].subject.id)[0]
          classId = classId ? classId[0] : null
        }

        let data = {
          attachments: log[1].attachments,
          date: log[1].date,
          title: log[1].title,
          notes: log[1].notes,
          category,
          categoryId: log[1].atl_category.id,
          className,
          skillCluster: log[1].skillCluster,
          classId,
          cluster,
          skill,
          id: log[0]
        }
        myLogs.push(data)
      })
      //Find classes of student
      let classes = []
      classes = this.props.school && this.props.school.classes && Object.entries(this.props.school.classes)
      classes = classes && classes.filter( clss =>
        clss[1].students
        &&
        Object.keys(clss[1].students).includes(this.props.auth.uid)
        &&
        !clss[1].archived
      )
      let years = []
      let current_year = moment().format('YYYY')
      if (this.props.school && this.props.school.academicYear && this.props.school.academicYear === 'January - December') {
        let i = 2018
        for (i; i <= current_year; i++) {
          let logs_in_year = myLogs.filter( log => 
            moment(log.date).format('YYYY') == i  
          )
          if (logs_in_year.length > 0 ) {
            years.push({
              year: i,
              logs: logs_in_year
            })
          }
        }
      } else {
        let i = 2017
        for (i; i <= current_year; i++) {
          let from = moment(`${i.toString()}08`, 'YYYYMM').valueOf()
          let to = moment(`${(i+1).toString()}08`, 'YYYYMM').valueOf()
          let logs_in_year = myLogs.filter( log => 
            moment(log.date).valueOf() > from 
            &&
            moment(log.date).valueOf() < to
          )
          if (logs_in_year.length > 0 ) {
            years.push({
              year: `${i} - ${i+1}`,
              logs: logs_in_year.reverse()
            })
          }
        }
      }

      let selectedYear = this.state.selectedYear
      if (!selectedYear) {
        selectedYear = years.length > 0 ? years[years.length - 1].year : null
      } 
      
      this.setState({
        years, 
        classes,
        selectedYear
      })
    }

    //Filter student's subjects
    if (this.props.school && this.props.school.classes && this.props.subjects && prevProps.school !== this.props.school) {
      let subjects = []
      let classes = this.props.school.classes && Object.entries(this.props.school.classes)
      classes = classes.filter( clss =>
          clss[1].students && clss[1].students.hasOwnProperty(this.props.auth.uid))
            .map( cls => {
              let subjectName = this.props.subjects && Object.entries(this.props.subjects).filter( subject =>
                  subject[0] == cls[1].subject
              )
              subjectName = subjectName[0][1].name
              if (!subjectName) { subjectName = 'subject not found'}
              subjects.push([cls[1].subject, {name: subjectName}])
            })

      this.setState({subjects})
    }

  }

  prepareUpload = (data) => {
    let uploadData = this.state.uploadData
    uploadData.push(data)
    this.setState({uploadData})
  }

  removeFile = (file) => {
    let uploadData = this.state.uploadData
    uploadData = uploadData.filter( data =>
      data.file.name !== file.name
    )
    this.setState({uploadData})
  }

  checkUpload = (data, toDelete) => {
    //Removing files in edit mode
    let attachments;
    if (toDelete && toDelete.length > 0 && this.state.editingLog) {
      attachments = this.props.logs[this.state.editingLog.id].attachments
      toDelete.map( file => {
        if (file.storagePath) {
          this.props.firebase.storage().ref().child(file.storagePath).delete().then(() => console.log('deleted!!'))
        }
        attachments = attachments.filter( item =>
          item.name !== file.name
        )
      })
    } else if (this.state.editingLog) {
      attachments = this.props.logs[this.state.editingLog.id].attachments

    }


    let uploadData = {}
    if (this.state.uploadData.length>0) {
      this.setState({addLogModal: false})
      let files = []
      this.state.uploadData.map( upload => {
        files.push(upload.file)
      })
      let uid = this.props.auth.uid
      let folder = moment().valueOf()
        this.props.firebase.uploadFiles(`attachments/${uid}/${folder}`, files)
          .then( (snapshot) => {
            uploadData = []
            snapshot.map( (file, index) => {
              uploadData.push({name: file.uploadTaskSnaphot.metadata.name, path: file.uploadTaskSnaphot.metadata.downloadURLs[0], storagePath: file.uploadTaskSnaphot.metadata.fullPath})
            })
            if (attachments) {
              uploadData = uploadData.concat(attachments)
            }
            this.addLog(data, uploadData)
            this.setState({uploadData: []})
          })
    } else {
      this.setState({addLogModal: false})
      this.addLog(data, attachments)
    }
  }



  addLog = (data, uploadData) => {
    if (!uploadData) { uploadData = "" }
    const date = moment().format();
    if (this.state.editingLog) {
      this.props.firebase.database().ref(`/logs/${this.state.editingLog.id}`).update({
        notes: data.notes,
        title: data.title,
        user_id: data.user_id,
        subject: {id: data.subject.id, name: data.subject.name},
        atl_category: {id: data.category.id, name: data.category.name},
        atl_cluster: {id: data.cluster.id, name: data.cluster.name},
        level_skill: {id: data.skill.id, name: data.skill.name},
        skillCluster: this.props.skillClusters[data.skillCluster],
        attachments: uploadData,
        classId: data.classId
      }).then( () => {
        this.badges.createBadgesTable('recreate')
        message.success('Updated!')
        this.setState({addLogModal: false, editingLog: null})
      })
    } else {
      this.badges.addLogToBadges(data)
      this.props.firebase.database().ref(`/logs/`).push({
        date: date,
        notes: data.notes,
        title: data.title,
        user_id: data.user_id,
        subject: {id: data.subject.id, name: data.subject.name},
        atl_category: {id: data.category.id, name: data.category.name},
        atl_cluster: {id: data.cluster.id, name: data.cluster.name},
        level_skill: {id: data.skill.id, name: data.skill.name},
        skillCluster: this.props.skillClusters[data.skillCluster],
        attachments: uploadData,
        classId: data.classId
      }).then( () => { message.success('Saved!')})
    }
  }

  openGallery = (index) => {
    this.setState({slide: index, LogGallery: true})
  }

  pageInfo = (logs) => {
    let currentPage;
    let totalPage;
    if (this.state.logsDisplayedFrom == 0) {
      currentPage = 1
    } else {
      currentPage = this.state.logsDisplayedFrom/10+1
    }
    totalPage = Math.ceil(logs.length/10)
    return currentPage+' / '+totalPage
  }

  getTheme = () => {
    let color;
    let background;
    const { theme_skill } = this.props.profile.profile
    switch (theme_skill) {
      case 'gray':
        color = '#7c868d'
        background = backgroundGray
        break;
      case 'pink':
        color = '#F190AC'
        background = backgroundPink
        break;
      case 'default':
        color = '#006588'
        background = backgroundBlue
        break;
      default:
        color = '#006588'
        background = backgroundBlue
    }
    if (color) {
      this.setState({color, background})
    } else {
      this.setState({color: '#107498'})
    }
  }

  changeTheme = (color) => {
    const { uid } = this.props.auth
    this.props.firebase.database().ref(`/users/${uid}/profile`).update({
      theme_skill: color
    }).then( () => this.getTheme())
  }

  getNoLogImg = () => {
    if (this.state.color == '#006588') {
      return nolog_blue
    } else if (this.state.color == '#F190AC') {
      return nolog_pink
    } else {
      return nolog_gray
    }
  }

  deleteLog = (log) => {
    this.props.firebase.database().ref(`logs/${log.id}`).remove()
      .then(() => {
        this.badges.createBadgesTable('recreate')
        message.success('Log deleted!')
      })
  }

  editLog = (log) => {
    this.setState({addLogModal: true, editingLog: log})
  }

  selectLog = (index, all, logs) => {
    let { selectedLogs } = this.state
    if (all) {
      logs.map( (log, i) => {
        selectedLogs.push(i)
      })
    } else {
      if (selectedLogs.includes(index)) {
        selectedLogs = selectedLogs.filter( item => item !== index)
      } else {
        selectedLogs.push(index)
      }
    }
    this.setState({selectedLogs})
  }

  exportToPdf = () => {
    this.layout.toExport.save(() => {
      this.setState({exportMode: false, selectedLogs: []})
    });
  }

  render() {
    const { t, products, lng } = this.props
    const { years, selectedYear, exportMode, view } = this.state

    const styles = {

      background: {
        backgroundImage: `url(${this.state.background})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        minHeight: '100vh',
        minWidth: '100vw',
      },
      addBtn: {
        fontSize: 50,
        fontFamily: 'Times new roman',
        color: 'white',
        backgroundColor: this.state.color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 60,
        width: 60,
        borderRadius: '50%',
        cursor: 'pointer',
        position: 'fixed',
        right: 25,
        bottom: 25,
        zIndex: 99
      },
      exportBtn: {
        height: 60,
        width: 60,
        borderRadius: '50%',
        cursor: 'pointer',
        position: 'fixed',
        left: 25,
        bottom: 25,
        zIndex: 99,
        backgroundColor: this.state.color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      },
      header: {
        backgroundColor: this.state.color,
        height: 77,
        marginBottom: 40,
        position: 'fixed',
        width: '100%',
        zIndex: 2,
        opacity: 0.95,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      gallery: {
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        paddingTop: 130,
        zIndex:99
      },
      closeicon: {
        position: 'absolute',
        right: 20,
        top: 20,
        color: 'white',
        fontSize: 50,
        opacity: 0.8,
        cursor: 'pointer',
        zIndex: 2
      },
      profileDiv: {
        position: 'absolute',
        right: 40,
        top: 5,
        height: 66,
        width: 66,
        overflow: 'hidden',
        borderRadius: '50%',
        cursor: 'pointer',
        boxShadow: 'rgb(0, 0, 0) 2px 3px 11px 0px'
      },
      button: {
        backgroundColor: this.state.color,
        color: 'white',
        border: 'none',
        borderRadius: '20px',
        width: 120
      },
      startButton: {
        backgroundColor: this.state.color,
        color: 'white',
        border: 'none',
        borderRadius: '20px',
        width: 'auto',
        margin: '0 auto',
        display: 'block'
      },
      pageNum: {
        width: 'max-content',
        padding: '6px 20px 0px 20px',
        backgroundColor: this.state.color,
        borderRadius: 20,
        color: 'white',
        fontSize: 14,
      },
      progress: {
        fontSize: 18,
        marginLeft: -30,
        marginTop: 6,
        color: 'white',
        cursor: 'pointer',
        width: 'max-content',
        fontFamily: 'Arial Rounded MT Bold',
        position: 'absolute',
        left: 60,
        top: 0

      },
      welcome: {
        fontSize: 24,
        marginTop: 40,
        marginBottom: 40,
        color: this.state.color,
        textAlign: 'center',
        fontFamily: 'Arial Rounded MT Bold'
      },
      exportBar: {
        width: '100%',
        height: 60,
        backgroundColor: this.state.color,
        width: '100%',
        top: 77,
        position: 'fixed',
        zIndex: 10,
        opacity: 0.95,
        borderTop: '1px solid white'
      },
      exportText: {
        fontSize: 16,
        marginLeft: 20,
        color: 'white',
        cursor: 'pointer',
        width: 'max-content',
        fontFamily: 'Helvetica Neue',
        marginTop: 17,
        display: 'inline-block'
      },
      product: {
        position: 'absolute',
        right: 128,
        top: 23,
        width: 30
      },
      viewLogo: {
        width: 30,
        height: 'auto',
        cursor: 'pointer',
        position: 'absolute'
      }
    }

    let logs = []
    if (years.length > 0) {
      logs = years.filter( item => item.year === selectedYear)[0].logs
    }
    const numberLogs = logs.length


    const productBox = (
      <Row style={{width: 200, zIndex: 11}}>
        <Col className='productBox' xs={12}>
          <img style={{width: 40, display: 'block', margin: '0 auto', marginTop: 20, border: '1px solid white'}} src={Skilllogo} />
          <h3 style={{fontSize: 12, color: this.state.color, marginBottom: 0, marginTop: 10, textAlign: 'center', fontFamily: 'Arial Rounded MT Bold' }}>Skill</h3>
          <h3 style={{fontSize: 12, color: this.state.color, marginBottom: 10, textAlign: 'center', fontFamily: 'Arial Rounded MT Bold'}}>Tracker</h3>
        </Col>
        <Col
          className='productBox'
          xs={12}
          style={{cursor: 'pointer'}}
          onClick={() => (products && products.includes('ServiceTracker')) ? this.props.switchProduct('ServiceTracker') : this.setState({unavailablePopup: true})}
          >
          <img style={{width: 40, display: 'block', margin: '0 auto', marginTop: 20, border: '1px solid white'}} src={Servicelogo} />
          <h3 style={{fontSize: 12, color: this.state.color, marginBottom: 0, marginTop: 10, textAlign: 'center', fontFamily: 'Arial Rounded MT Bold' }}>Service</h3>
          <h3 style={{fontSize: 12, color: this.state.color, marginBottom: 10, textAlign: 'center', fontFamily: 'Arial Rounded MT Bold'}}>Tracker</h3>
        </Col>
      </Row>
    )



    return (
      <div style={styles.background} id="studentApp">
        {!this.state.exportMode &&
          <div>
            <Tooltip title={t("Add new log")}>
              <div onClick={() => this.setState({addLogModal: true})} id='addLog' style={styles.addBtn}>+</div>
            </Tooltip>
            {view === 'logs' && 
              <Tooltip title={t("Export to PDF")}>
                <div onClick={() => this.setState({exportMode: true})} style={styles.exportBtn}><Icon style={{fontSize: 26, color: 'white'}} type="export" /></div>
              </Tooltip>
            }
          </div>
        }
        {this.state.LogGallery &&
          <div>
            <div className='overlay'></div>
            <div style={styles.gallery}>
              <Icon onClick={() => this.setState({LogGallery: false})} style={styles.closeicon} type="close" />
              <LogGallery color={this.state.color} data={logs} slide={this.state.slide} t={t}/>
            </div>
          </div>
        }
          <Header style={styles.header}>
            <h1 className='noAvenir' style={styles.progress} onClick={() => this.setState({badgesOpen: true, exportMode: false, selectedLogs: []})}>{t('My Progress')}</h1>
              <img src={dashboardImage} style={{...styles.viewLogo, right: 177}} onClick={() => this.setState({ view: 'dashboard' })} />
              <img src={logsImage} style={{ ...styles.viewLogo, right: 221 }} onClick={() => this.setState({view: 'logs'})} />
            <div style={styles.profileDiv} onClick={() => this.setState({profileOpen: true,  exportMode: false, selectedLogs: []})}>
              <img style={{width: '100%', height: 'auto'}} src={this.props.profile.profile.image || this.props.auth.photoURL || profileImage} />
            </div>
            {view === 'logs' &&
              <Radio.Group value={selectedYear} size="large" onChange={e => !exportMode && this.setState({ selectedYear: e.target.value })}>
                {years.map(year => (
                  <Radio.Button style={{ color: this.state.color, cursor: exportMode && 'not-allowed' }} value={year.year}>{year.year}</Radio.Button>
                ))}
              </Radio.Group>
            }
            {serviceTracker_allowed &&
              <Popover content={productBox} placement="bottom">
                <img src={Switch} style={styles.product}/>
              </Popover>
            }
          </Header>
          {this.state.exportMode &&
            <div style={styles.exportBar}>
              <h1 style={styles.exportText} className='noAvenir'>{t('Select the logs you would like to export')}
                {this.state.selectedLogs.length > 0
                  ?
                    lng == 'FR'
                    ? ` • Sélection : ${this.state.selectedLogs.length}`
                    :` • ${this.state.selectedLogs.length} selected`

                  : ''
                }
              </h1>
              <div style={{width: 'max-width', float: 'right', marginTop: 14}}>
                <Button style={{marginRight: 20}} onClick={() => this.setState({exportMode: false, selectedLogs: []})} type="danger">{t('Cancel')}</Button>
                <Button style={{marginRight: 20}} onClick={() => this.selectLog(null, true, logs)}>{t('Select All')}</Button>
                <Button disabled={this.state.selectedLogs.length == 0} style={{marginRight: 20}} onClick={() => this.exportToPdf()}>{t('Export')}</Button>
              </div>
            </div>
          }
          <Content style={{paddingTop: this.state.exportMode ? 177 : 100}}>
            {this.state.view === 'logs'
            ? <div style={{ margin: '0 auto', maxWidth: 1000 }}>
                {logs.length == 0 &&
                  <div style={{ marginTop: '10%' }}>
                    <img style={{ display: 'block', margin: '0 auto' }} src={this.getNoLogImg()} />
                    <h1 className='noAvenir' style={styles.welcome}>{t('Welcome! Ready to start logging skills?')}</h1>
                    <Button onClick={() => this.setState({ addLogModal: true })} style={styles.startButton}>{t("Let's get started!")}</Button>
                  </div>
                }
                <Row>
                  {logs.length > 0 &&
                    logs.slice(this.state.logsDisplayedFrom, this.state.logsDisplayedFrom + 10).map((log, index) =>
                      <Col xs={12}
                        style={{
                          padding: 10,
                          opacity: this.state.exportMode
                            ? this.state.selectedLogs.includes(index) ? 1 : 0.6
                            : 1
                        }}
                        onClick={() => this.state.exportMode && this.selectLog(index)}
                        onMouseEnter={() => !this.state.exportMode && this.setState({ hoverOn: index })}
                        onMouseLeave={() => !this.state.exportMode && this.setState({ hoverOn: null })}
                      >
                        <Log
                          t={this.props.t}
                          data={log}
                          color={this.state.color}
                          editButtons={this.state.hoverOn == index && true}
                          openGallery={() => !this.state.exportMode && this.openGallery(this.state.logsDisplayedFrom + index)}
                          deleteLog={() => this.deleteLog(log)}
                          editLog={() => this.editLog(log)}
                        />
                      </Col>
                    )
                  }
                  {logs.length > 20 &&
                    <Col xs={24} style={{ display: 'inline-flex', justifyContent: 'space-between', padding: '10px 10px 20px 10px' }}>
                      <Button className={this.state.logsDisplayedFrom < 9 && 'hidden'} style={styles.button} onClick={() => this.setState({ logsDisplayedFrom: this.state.logsDisplayedFrom - 10 })}>{t('Previous')}</Button>
                      <div style={styles.pageNum}>{this.pageInfo(logs)}</div>
                      <Button className={this.state.logsDisplayedFrom + 10 > numberLogs && 'hidden'} style={styles.button} onClick={() => this.setState({ logsDisplayedFrom: this.state.logsDisplayedFrom + 10 })}>{t('Next')}</Button>
                    </Col>
                  }
                </Row>
              </div>

              : <DashboardView 
                  logs={Object.entries(this.props.logs).filter(log => log[1].user_id === this.props.auth.uid)} 
                  t={t} 
                  color={this.state.color}
                  subjects={this.state.subjects}
                />
            }
          </Content>
          <AddLog
            color={this.state.color}
            open={this.state.addLogModal}
            close={() => this.setState({addLogModal: false})}
            subjects={this.state.subjects}
            category={this.props.category}
            cluster={this.props.cluster}
            skill={this.props.skill}
            prepareUpload={this.prepareUpload}
            removeFile={this.removeFile}
            uid={this.props.auth.uid}
            addLog={this.checkUpload}
            skill_description={this.props.school && this.props.school.skill_description}
            subjectGroups={this.state.subjectGroups}
            upload={this.state.uploadData}
            classes={this.state.classes}
            t={this.props.t}
            editingLog={this.state.editingLog}
            skillClusters={this.props.skillClusters}
          />
          <StudentProfile
            product={'Skill'}
            color={this.state.color}
            open={this.state.profileOpen}
            close={() => this.setState({profileOpen: false})}
            data={this.props.profile.profile}
            image={this.props.profile.profile.image || this.props.auth.photoURL || profileImage}
            uid={this.props.auth.uid}
            changeTheme={this.changeTheme}
            changeLanguage={this.props.changeLanguage}
          />
          <Badges
            open={this.state.badgesOpen}
            color={this.state.color}
            close={() => this.setState({badgesOpen: false})}
            category={this.props.category}
            level_skill={this.props.skill}
            uid={this.props.auth.uid}
            onRef={ref => (this.badges = ref)}
          />
          {this.state.exportMode &&
            <PDFLayout
              ref={(r) => this.layout = r}
              logs={logs}
              selected={this.state.selectedLogs}
              color={this.state.color}
              t={this.props.t}
              profile={this.props.profile}
              moment={moment}
            />
          }
          <UnavailablePopup
            open={this.state.unavailablePopup}
            close={() => this.setState({unavailablePopup: false})}
            color={this.state.color}
          />
      </div>
    )
  }
}

const enhancer = compose(
  translate('lang'),
  firebaseConnect((props, store) => {
    const state = store.getState()
    const schoolId = R.path(['firebase','profile','profile','school','id'], state)
    const paths = ['subjects', 'profile', 'atl_category', 'atl_cluster', 'atl_skill', 'level_skills', 'classes']
    if (schoolId) {
      paths.push(`/schools/${schoolId}`);
    }
    return paths;
  }),
  connect(
    state => {
      const schoolId = state.firebase.profile.profile.school && state.firebase.profile.profile.school.id
      return {
        auth: state.firebase && state.firebase.auth,
        profile: state.firebase.profile || {},
        subjects: state.firebase.data.subjects || {},
        category: state.firebase.data.atl_category || {},
        cluster: state.firebase.data.atl_cluster || {},
        skill: state.firebase.data.level_skills || {},
        logs: state.firebase.data.logs || {},
        skillClusters: state.firebase.data.atl_skill || {},
        school: state.firebase.data.schools && state.firebase.data.schools[schoolId],
      }
    }
  )
)
export default withRouter(enhancer(Skill))



// WEBPACK FOOTER //
// ./src/containers/StudentApp/Skill.jsx